// Sürüm numarası sunucudan gelir; her yeni yayın (derleme) sürümü otomatik 1 artırır
import { useEffect, useState } from 'react';
import axios from 'axios';

export const BUILD_ID = process.env.REACT_APP_BUILD_ID || 'dev';
export const RELEASE = 1;
export const APP_VERSION = `V.${1 + Math.floor(RELEASE / 21)}.${RELEASE % 21}`;

let cache = null;
let pending = null;

export const useAppVersion = () => {
  const [info, setInfo] = useState(cache || { version: APP_VERSION, date: '' });
  useEffect(() => {
    if (cache) return;
    pending = pending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/app-version`, { params: { build: BUILD_ID } })
      .then(r => { cache = r.data; return cache; })
      .catch(() => { pending = null; return null; });
    pending.then(d => d && setInfo(d));
  }, []);
  return info;
};
